import { createSlice } from "@reduxjs/toolkit";
import { fetchPendingDispatch } from "./thunk";

interface PendingDispatchState {
  PendingDispatchList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PendingDispatchState = {
  PendingDispatchList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const PendingDispatchSlice = createSlice({
  name: "PendingDispatch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.PendingDispatchList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPendingDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Purchase Order";
      });
  },
});

export default PendingDispatchSlice.reducer;
